<template>
  <b-navbar-nav>
    <b-nav-item
      v-for="(lang, index) in inactiveLanguages"
      :key="index"
      @click="updateActiveLanguage(lang)"
    >
      {{ lang | uppercase }}
    </b-nav-item>
  </b-navbar-nav>
</template>

  <script>
export default {
  name: "NavbarLanguageSwitch",
  data: function() {
    return {
      availableLangs: [],
      activeLanguage: "",
      test: 1
    };
  },
  computed: {
    inactiveLanguages: function() {
      let that = this;
      return this.availableLangs.filter(function(value) {
        return value !== that.activeLanguage;
      });
    }
  },
  created() {
    this.activeLanguage = this.$i18n.locale;
    this.availableLangs = this.$i18n.availableLocales;
  },
  methods: {
    updateActiveLanguage: function(lang) {
      this.activeLanguage = lang;
    }
  },
  watch: {
    activeLanguage: function() {
      this.$root.$i18n.locale = this.activeLanguage;
      if (this.$route.params.lang != this.activeLanguage) {
        this.$router.push({
          name: this.$route.name,
          params: { lang: this.$root.$i18n.locale }
        });
      }
    }
  }
};
</script>
